import { makeStyles, tokens } from '@fluentui/react-components';
import { useState } from 'owa-react';
import React from 'react';

const useStyles = makeStyles({
    brandColor: {
        color: tokens.colorNeutralForeground2BrandHover,
        '@media (forced-colors: active)': {
            color: 'inherit',
        },
    },
});

export interface IconFillOnHover {
    filled: boolean;
    iconColorClassName: string | undefined;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}

/**
 * Returns the `filled` flag, brand-color icon class, and mouse handlers used to
 * give a header icon button the Fluent v9 fill-on-hover behavior. Only the icon
 * is affected; nothing is merged onto the button root.
 */
export function useIconFillOnHover(): IconFillOnHover {
    const styles = useStyles();
    const [filled, setFilled] = useState(false);
    const onMouseEnter = React.useCallback(() => setFilled(true), []);
    const onMouseLeave = React.useCallback(() => setFilled(false), []);

    return {
        filled,
        iconColorClassName: filled ? styles.brandColor : undefined,
        onMouseEnter,
        onMouseLeave,
    };
}
